export class OrderDetailsModel{
    public email: string = '';
    public order_id:string = '';
}

export class DocumentModel{
    public document_name = '';
    public document_url = '';
    public is_downloadable = false;
}
export class ProductModel{
    document: Array<DocumentModel> = [];
    product_name: string = "";
}

export class OrderDetailResponseModel{
    public amount: number = 0;
    public date_paid:string = "";
    public email: string = "";
    public order_id: string = "";
    public order_status: string = "";
    public product: Array<ProductModel> = [];

}